import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import NetworkAnnouncementsPage from "@/pages/admin/NetworkAnnouncementsPage";

export const Route = createFileRoute("/_admin/admin/network-announcements")({
  head: () => pageHead("Admin · Network Announcements", "AKIVA admin · network announcements portal.", "/admin/network-announcements", true),
  component: NetworkAnnouncementsPage,
});
